export default __webpack_public_path__ + "static/media/Asset 1.a9a4f9a0.png";